module.exports = __webpack_public_path__ + "static/media/barter-kings.0c36e91d.jpg";